import 'css-chunksrc/client/scenes/listDuplication/listsList/list/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_jbob6_1",
  "list": "_list_jbob6_5",
  "main": "_main_jbob6_12",
  "allocation": "_allocation_jbob6_1",
  "picture": "_picture_jbob6_28",
  "summary": "_summary_jbob6_34",
  "menu": "_menu_jbob6_43",
  "addAllocationIcon": "_addAllocationIcon_jbob6_47",
  "resourcesList": "_resourcesList_jbob6_53",
  "up": "_up_jbob6_60",
  "quickAllocationMenu": "_quickAllocationMenu_jbob6_65",
  "overlay": "_overlay_jbob6_70"
};